__turbopack_context__.v({
  "confirmation": "dQ3z5q_confirmation",
  "h2": "dQ3z5q_h2",
  "h3": "dQ3z5q_h3",
  "h4": "dQ3z5q_h4",
  "text": "dQ3z5q_text",
});
